import { create } from 'zustand';

import type { DrawerProps } from 'antd';

type TDrawerState = {
  openDrawer: boolean;
  pinnedDrawer: boolean;
  setOpenDrawer: (open: boolean) => void;
  configDrawer?: DrawerProps;
  setConfigDrawer: (configDrawer: DrawerProps) => void;
  onRefreshDrawer?: () => void;
  setOnRefreshDrawer: (onRefreshDrawer: () => void) => void;
  setPinnedDrawer: (pinned: boolean) => void;
};

const drawerStore = create<TDrawerState>((set) => ({
  openDrawer: false,
  pinnedDrawer: false,
  configDrawer: {},
  onRefreshDrawer: () => {
    /* empty */
  },
  setOnRefreshDrawer: (onRefreshDrawer) => set({ onRefreshDrawer }),
  setOpenDrawer: (openDrawer) => set({ openDrawer }),
  setConfigDrawer: (configDrawer) => set({ configDrawer }),
  setPinnedDrawer: (pinnedDrawer) => set({ pinnedDrawer }),
}));

export const useDrawer = () => {
  const openDrawer = drawerStore((state) => state.openDrawer);
  const pinnedDrawer = drawerStore((state) => state.pinnedDrawer);
  const onRefreshDrawer = drawerStore((state) => state.onRefreshDrawer);
  const configDrawer = drawerStore((state) => state.configDrawer);

  const setOpenDrawer = drawerStore((state) => state.setOpenDrawer);
  const setPinnedDrawer = drawerStore((state) => state.setPinnedDrawer);
  const setOnRefreshDrawer = drawerStore((state) => state.setOnRefreshDrawer);
  const setConfigDrawer = drawerStore((state) => state.setConfigDrawer);

  return {
    openDrawer,
    configDrawer,
    onRefreshDrawer,
    setOnRefreshDrawer,
    setConfigDrawer,
    setOpenDrawer,
    pinnedDrawer,
    setPinnedDrawer,
  };
};

export const useDrawerActions = () => {
  const setOpenDrawer = drawerStore((state) => state.setOpenDrawer);
  const setPinnedDrawer = drawerStore((state) => state.setPinnedDrawer);
  const setOnRefreshDrawer = drawerStore((state) => state.setOnRefreshDrawer);
  const setConfigDrawer = drawerStore((state) => state.setConfigDrawer);

  return {
    setOpenDrawer,
    setPinnedDrawer,
    setOnRefreshDrawer,
    setConfigDrawer,
  };
};
